import ColumnsLayoutRenderer from 'src/common/components/columns/ColumnsLayoutRenderer';
import { LanguageKeys } from 'src/common/constants/languages';
import { evaluateVisibilityFilter, VisibilityContext } from 'src/helpers/visibilityFilter';
import { PlaceholderRenderContext } from 'src/helpers/placeholderRegistry';
import { IColumnsBlock } from 'src/interfaces/PageBlock';
import { IEdition } from 'src/interfaces/Edition';

interface Props {
  block: IColumnsBlock;
  lang: LanguageKeys;
  visibilityContext: VisibilityContext;
  placeholderContext: PlaceholderRenderContext;
  currentEdition?: IEdition;
  inHero?: boolean;
  applyVisibilityRules?: boolean;
  contentKey?: string;
}

export default function ColumnsBlockContent({
  block,
  lang,
  visibilityContext,
  placeholderContext,
  currentEdition,
  inHero,
  applyVisibilityRules = true,
  contentKey,
}: Props) {
  if (
    applyVisibilityRules &&
    !evaluateVisibilityFilter(block.visibility, visibilityContext)
  ) {
    return null;
  }

  return (
    <ColumnsLayoutRenderer
      layout={block}
      lang={lang}
      visibilityContext={visibilityContext}
      placeholderContext={placeholderContext}
      currentEdition={currentEdition}
      inHero={inHero}
      applyVisibilityRules={applyVisibilityRules}
      contentKey={contentKey}
    />
  );
}
